import { TipoCalculoRastreamentoEnum } from "./parametros-vo";
import { TipoGPSEnum } from "./rota-vo";

export interface ResumoPlanejadoExecutado {
  id: string;
  data: string;
  distancia: number;
  momento: string;
  tempo: string;
  valor?: number;
  visitas: number;
  tempoNumero: number;
  removido: boolean;
  calculoKmExecutado: TipoCalculoRastreamentoEnum;
  tipoRastreamento: TipoGPSEnum;
}

export const emptyResumoPE = (): ResumoPlanejadoExecutado => ({
  visitas: 0,
  tempoNumero: 0,
  distancia: 0,
  data: '',
  id: '',
  momento: '',
  removido: false,
  tempo: '',
  valor: 0,
  calculoKmExecutado: TipoCalculoRastreamentoEnum.PATHFIND,
  tipoRastreamento: TipoGPSEnum.PATHFIND,
});
